import Input from 'components/Input';
import MaskedInput from 'components/MaskedInput';
import { FormikTouched } from 'formik';
import React, { useContext, useState } from 'react';
import { cpfMask, unMask } from 'utils/mask';
import { FaEdit, FaCheckCircle, FaRegTimesCircle } from 'react-icons/fa';
import * as S from './styles';
import * as CXT from 'context/globalContext';
import {
  FormPropsPJType,
  SocioFormPropsType,
} from 'pages/Register/utils/types/FormPropType/FormPropPJType';
import Button from 'components/Button';
import { IconButton } from '@mui/material';
import { find, map, reverse, sortBy } from 'lodash';
import { Person } from 'services/client';
import { toast } from 'react-toastify';

type InputsAndSelectsOfPartnersDataProps = {
  values: FormPropsPJType;
  errorsForm: FormPropsPJType | undefined;
  successForm: FormPropsPJType | undefined;
  touched: FormikTouched<FormPropsPJType>;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
};

export const InputsAndSelectsOfPartnersData: React.FC<
  InputsAndSelectsOfPartnersDataProps
> = ({ values, setFieldValue }) => {
  const globalContext = useContext(CXT.Context);
  const [socioCpf, setSocioCpf] = useState('');
  const [loadingSocio, setLoadingSocio] = useState(false);

  const [editingSocio, setEditingSocio] = useState<
    SocioFormPropsType | undefined
  >(undefined);

  const adicionarSocio = () => {
    setLoadingSocio(true);

    Person.ClientRequest(unMask(socioCpf, '[^0-9]'))
      .then((response) => {
        const pessoa = response?.data?.data;

        const socio = {
          pessoaSocioId: pessoa.id,
          cpfCnpj: unMask(socioCpf, '[^0-9]'),
          nome: pessoa.nome,
        };
        setFieldValue('socios', [...(values.socios ?? []), socio]);
        setSocioCpf('');
        setEditingSocio(socio);
      })
      .catch(() => {
        toast.error('Não foi possível encontrar pessoa com o CPF informado');
      })
      .finally(() => {
        setLoadingSocio(false);
      });
  };

  const salvarParticipacao = () => {
    const socio = find(
      values.socios,
      (it) => it.cpfCnpj === editingSocio?.cpfCnpj
    );
    if (socio) {
      socio.percentualSocietario = editingSocio?.percentualSocietario;
    }
    setEditingSocio(undefined);
    // TODO atualizar no form
  };

  const removerSocio = (cpfCnpj: string) => () => {
    setFieldValue(
      'socios',
      values.socios?.filter((it) => it.cpfCnpj !== cpfCnpj)
    );
  };

  return (
    <S.Wrapper>
      <S.Container>
        {(values.socios?.length ?? 0) > 0 && !globalContext.isLoading && (
          <S.SocioWrapper>
            <S.SocioNome>Nome</S.SocioNome>
            <S.SocioParticipacao>% Part.</S.SocioParticipacao>
            <S.SocioAcao></S.SocioAcao>
            <S.SocioAcao></S.SocioAcao>
          </S.SocioWrapper>
        )}
        <S.ContentContainer>
          {!values.socios?.length && !globalContext.isLoading && (
            <S.SemSocios>
              <S.TextLine>Nenhum sócio cadastrado.</S.TextLine>
              <S.TextLine>Adicione os sócios de sua empresa</S.TextLine>
            </S.SemSocios>
          )}
          {!globalContext.isLoading &&
            map(
              reverse(
                sortBy(values.socios, (it) =>
                  Number(it.percentualSocietario ?? 100)
                )
              ),
              (socio) => (
                <S.SocioWrapper key={socio.cpfCnpj}>
                  <S.SocioNome>{socio.nome}</S.SocioNome>
                  {editingSocio && editingSocio.cpfCnpj === socio.cpfCnpj ? (
                    <>
                      <S.SocioParticipacao>
                        <Input
                          id="percentualSocietario"
                          name="percentualSocietario"
                          title=""
                          value={
                            editingSocio.percentualSocietario
                              ? `${editingSocio.percentualSocietario}`
                              : undefined
                          }
                          onChange={(event) => {
                            setEditingSocio({
                              ...editingSocio,
                              percentualSocietario: event.target.value,
                            });
                          }}
                          placeholder="%"
                          error={(editingSocio.percentualSocietario ?? 0) > 100}
                          errorMessage="Máx. 100%"
                        ></Input>
                      </S.SocioParticipacao>
                      <S.SocioAcao></S.SocioAcao>
                      <S.SocioAcao>
                        <IconButton
                          onClick={salvarParticipacao}
                          color="primary"
                          disabled={
                            !editingSocio.percentualSocietario ||
                            editingSocio.percentualSocietario > 100
                          }
                        >
                          <FaCheckCircle size={18} />
                        </IconButton>
                      </S.SocioAcao>
                    </>
                  ) : (
                    <>
                      <S.SocioParticipacao>
                        {socio.percentualSocietario}
                      </S.SocioParticipacao>
                      <S.SocioAcao>
                        <IconButton
                          onClick={() => {
                            setEditingSocio(socio);
                          }}
                          disabled={!!editingSocio}
                        >
                          <FaEdit size={18} />
                        </IconButton>
                      </S.SocioAcao>
                      <S.SocioAcao>
                        <IconButton
                          onClick={removerSocio(socio.cpfCnpj)}
                          disabled={!!editingSocio}
                        >
                          <FaRegTimesCircle size={18} />
                        </IconButton>
                      </S.SocioAcao>
                    </>
                  )}
                </S.SocioWrapper>
              )
            )}
        </S.ContentContainer>
        <S.AddContainer>
          <S.DivInput>
            <MaskedInput
              id="cpf"
              name="cpf"
              title="CPF"
              value={socioCpf}
              disabled={loadingSocio || !!editingSocio}
              onChange={(event) => {
                setSocioCpf(cpfMask(event.target.value));
              }}
              placeholder="Digite o CPF"
              MaskType={'cpf'}
            />
            <Button
              onClick={adicionarSocio}
              marginTop="8px"
              type="button"
              loading={loadingSocio}
              disabled={!!editingSocio || !socioCpf}
            >
              Adicionar Sócio
            </Button>
          </S.DivInput>
        </S.AddContainer>
      </S.Container>
    </S.Wrapper>
  );
};
